import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.egpro.app/api';
// export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },
};

export const customerAPI = {
  // Get all customers
  getCustomers: async (page = 1, limit = 20, search = '', isActive = undefined) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    
    if (search) params.append('search', search);
    if (isActive !== undefined) params.append('isActive', isActive.toString());
    
    const response = await api.get(`/admin/users?${params}`);
    return response.data;
  },

  // Get single customer
  getCustomer: async (userId) => {
    const response = await api.get(`/admin/users/${userId}`);
    return response.data;
  },

  // Create customer
  createCustomer: async (customerData) => {
    const response = await api.post('/admin/users', customerData);
    return response.data;
  },

  // Update customer
  updateCustomer: async (userId, customerData) => {
    const response = await api.put(`/admin/users/${userId}`, customerData);
    return response.data;
  },

  // Delete customer
  deleteCustomer: async (userId) => {
    const response = await api.delete(`/admin/users/${userId}`);
    return response.data;
  },

  // Test SSH connection
  testSSH: async () => {
    const response = await api.get('/admin/test-ssh');
    return response.data;
  },
};

export const adminCommandsAPI = {
  // Disable system for a specific customer
  disableSystem: async (userId) => {
    const response = await api.post(`/admin/users/${userId}/disable-system`);
    return response.data;
  },
  // Enable system for a specific customer
  enableSystem: async (userId) => {
    const response = await api.post(`/admin/users/${userId}/enable-system`);
    return response.data;
  },
  /** High temperature threshold °F (or device units) -> customer/{id}/device/program/system_setpoint */
  setSystemSetpoint: async (userId, setpoint) => {
    const response = await api.post(`/admin/users/${userId}/system-setpoint`, {
      setpoint,
    });
    return response.data;
  },
};

export default api;
